export default function calculQuotient(revenuFiscal, nbPart) {
    if (!revenuFiscal) {
        return 0;
    }
    return Math.round(revenuFiscal / nbPart / 12);
}
